import React,{ Component } from 'react';
import { connect }         from 'react-redux';
import {Redirect}          from 'react-router-dom';
import {iframe }           from '../../actions/jogosAction'
import {Config}            from '../../actions/configActions';

class Jogos extends Component {

	constructor(props){
		super(props);
		this.state = {
					  jog_id   : 1,
					  cur_id   : (this.props.session.cur_id ? this.props.session.cur_id:1),
					  redirect : false
					  
					}
	}

	renderJogo(){

		const obj = {}		
    	switch (parseInt(this.props.match.params.id)) {
			case 1:
				obj.retorno = this.props.iframe(`${Config().ip}/animacoes/wally/wally.html`);
			break;

			case 2:
				obj.retorno = this.props.iframe(`${Config().ip}/animacoes/fruit_ninja/ninja.html`);
			break;
		
			default:
			  this.setState({redirect:true})
			break;
		}
		return obj.retorno; 
	}

	render(){

		if (this.state.redirect) {

			return (<Redirect to={'/home/jogos'}/>);
		}

		return(
		 <div className="container-bg">
            <div className="titulo-pages topo_conteudo">
		     	<span>Jogo</span>
			</div>
			<div dangerouslySetInnerHTML={{__html: this.renderJogo()}}/>
			<div className="alert alert-info">
			   <b>Atenção: </b>Sua pontuação só será atualizada se você ganhar mais XP ou pontos do que na sua última tentativa. Ou seja, só será considerada a maior pontuação obtida.	
			</div>
		</div>
		);
	}
}

function mapStateToProps(state){
	
		return {
				 session : state.auth.session
			   };
	}


export default connect(mapStateToProps, {iframe})(Jogos);




// WEBPACK FOOTER //
// ./src/components/jogos/jogo.js